import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteCountry } from 'API/Country/deleteCountry';

const useDeleteCountry = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const deleteCountryById = async (countryId) => {
        try {
            const response = await deleteCountry(countryId);
            return response.data;
        } catch (error) {
            console.error('Error deleting country:', error);
            throw error;
        }
    };

    return useMutation({
        mutationFn: deleteCountryById,
        onSuccess: (data, countryId) => {
            queryClient.invalidateQueries({ queryKey: ['Countries'] });
            queryClient.removeQueries({
                queryKey: ['Country', countryId],
            });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useDeleteCountry;
